module.exports = __webpack_public_path__ + "static/media/trn-1.26c6bd40.jpg";